import { AxiosError } from 'axios'
import * as E from 'fp-ts/lib/Either'
import { ValidationError } from 'io-ts'
import { failure } from 'io-ts/lib/PathReporter'

// INFO https://wbinnssmith.com/blog/subclassing-error-in-modern-javascript/
// NOTE: don't use ClassName.name as name's value, it gets minified away on build

export class GeneralApiError extends Error {
  public readonly name = 'GeneralApiError'
  constructor(readonly cause: AxiosError<any>) {
    super(cause.message)
  }
}

export class UnauthorizedError extends Error {
  public readonly name = 'UnauthorizedError'
  constructor() {
    super('Unauthorized')
  }
}

export type ApiError = GeneralApiError | UnauthorizedError

export class ApiErrorHolder extends Error {
  public readonly name = 'ApiErrorHolder'
  constructor(readonly err: ApiError) {
    super(err.message)
  }
}

export function toApiError(err: AxiosError): ApiError {
  if (!err.response) {
    return new GeneralApiError(err)
  }

  switch (err.response.status) {
    case 401:
      return new UnauthorizedError()
    default:
      return new GeneralApiError(err)
  }
}

export class DecodeError extends Error {
  public readonly name = 'DecodeError'
  constructor(readonly errors: any[]) {
    super('Payload decoding failed')
  }
}

export function getOrThrow<A>(maybeErrors: E.Either<ValidationError[], A>): A {
  if (E.isRight(maybeErrors)) {
    return maybeErrors.right
  }

  throw new DecodeError(failure(maybeErrors.left))
}
